import { string, object, number, mixed, array, boolean } from 'yup';

import { YUP_ERRORS_MESSAGES } from '@shared/constants';
import { getRewardValueValidationSchema } from '@shared/utils';

import { UserRewardType } from 'v2/constants';

export const vipTaskItemValidationSchema = object().shape({
  title: string().trim().required(YUP_ERRORS_MESSAGES.REQUIRED),
  rewardIds: array().of(
    object().shape({
      type: mixed().oneOf(Object.values(UserRewardType)).required(YUP_ERRORS_MESSAGES.REQUIRED),
      value: getRewardValueValidationSchema(),
    })
  ),
  order: number().required(YUP_ERRORS_MESSAGES.REQUIRED),
  reuseInterval: number(),
  isDisabled: boolean(),
});
